module.exports = __webpack_public_path__ + "img/n1-1.a343df4c.png";